import { render } from "./LocationsWithContactsStep.vue?vue&type=template&id=b65cc6d0&scoped=true"
import script from "./LocationsWithContactsStep.vue?vue&type=script&lang=js"
export * from "./LocationsWithContactsStep.vue?vue&type=script&lang=js"

import "./LocationsWithContactsStep.vue?vue&type=style&index=0&id=b65cc6d0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b65cc6d0"]])

export default __exports__